module.exports = __webpack_public_path__ + "static/media/di308.f70d565b.pdf";